export default __webpack_public_path__ + "static/bear-1fe849427ca94d7e55d67df5dcf158f8.png";